import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Form, Field } from "react-final-form";
import { Button } from "ui/shared/components/Buttons";
import { validate } from 'data/account/validators/sign_up';
import Input from "ui/shared/components/form/Input";
import FieldContainer from "ui/shared/containers/form/FieldContainer";
import ErrorContainer from "ui/shared/containers/form/ErrorContainer";
import PhoneNumberInput from 'ui/shared/components/form/PhoneNumberInput';
import CountrySelector from "ui/shared/components/form/CountrySelector";
import { useDispatch, useSelector } from "react-redux";
import { submitSignUp } from 'data/account/actions/signUp';
import { generate } from "../../../routing/routes";

export default function SignUp() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { email } = useSelector(state => state.account.signInModal);
    const { signInModal } = useSelector(state => state.account);
    const [selectedCountry, setSelectedCountry] = useState();
    const [defaultCountry, setdefaultCountry] = useState();

    const handleChangeCountry = (value) => {
        setSelectedCountry(value);
        setdefaultCountry(value);
    }

    const inputClass = "rounded-md w-full border-gray-300";

    

    return (
        <Form
            onSubmit={(values) => {
                values.email = email;
                return (
                    dispatch(submitSignUp(values))
                    .then(() => (
                        window.location = signInModal && signInModal.targetUrl ? signInModal.targetUrl : generate("account_dashboard")
                    )))
            }}
            validate={validate}
   >



            {({ handleSubmit, pristine, form, submitting, invalid, values, validating }) => {
                return (
                    <form className="flex flex-col gap-2 sm:w-[400px]" onSubmit={handleSubmit}>
                        <FieldContainer form="sign_up" name="firstName" className={""}>
                            <Field className={inputClass} id="firstName" name="firstName" placeholder={t('account_button.first_name')} component={Input} type="text" />

                            <ErrorContainer form="sign_up" name="firstName" className="help-block" />
                        </FieldContainer>

                        <FieldContainer form="sign_up" name="lastName" className={""}>
                            <Field className={inputClass} id="lastName" name="lastName" placeholder={t('account_button.last_name')} component={Input} type="text" />

                            <ErrorContainer form="sign_up" name="lastName" className="help-block" />
                        </FieldContainer>

                        

                        <FieldContainer form="sign_up" name="country" className={""} >
                            <Field lassName={inputClass} id="country" name="country" onChange={handleChangeCountry} placeholder={t('account_button.country')} component={CountrySelector}
                            />

                            <ErrorContainer form="sign_up" name="country" className="help-block" />
                        </FieldContainer>

                        {selectedCountry && selectedCountry.value === 'FR' &&
                        <FieldContainer form="sign_up" name="postalCode" className={""}>
                            <Field className={inputClass} id="postalCode" name="postalCode" placeholder="Code postal" component={Input} type="number" />

                            <ErrorContainer form="sign_up" name="postalCode" className="help-block" />
                        </FieldContainer>}

                        <FieldContainer form="sign_up" name="phoneNumber" className={""}>
                            <Field className={inputClass} defaultCountry={defaultCountry} id="phoneNumber" name="phoneNumber" component={PhoneNumberInput} inputClass={"rounded-none"} />

                            <ErrorContainer form="sign_up" name="phoneNumber" className="help-block" />
                        </FieldContainer>

                        <FieldContainer form="sign_up" name="password" className={""}>
                            <Field className={inputClass} id="password" name="password" placeholder={t('account_button.password')} component={Input} type="password" />

                            <ErrorContainer form="sign_up" name="password" className="help-block" />
                        </FieldContainer>

                        <div className="checkbox max-w-[50vw] min-w-[300px]">
                            <label htmlFor="optInForNewsletter">
                                <Field id="optInForNewsletter" name="optInForNewsletter" className="mr-0.5 h-4 w-4 rounded border-stone-400 text-orange-600 focus:ring-orange-500" component="input" type="checkbox" />
                                {' '}{t('account_button.optin')}.
                            </label>
                        </div>

                        <div className="checkbox max-w-[50vw] min-w-[300px]">
                            <label htmlFor="cgv">
                                <Field id="cgv" name="cgv" component="input" type="checkbox" className="mr-0.5 h-4 w-4 rounded border-stone-400 text-orange-600 focus:ring-orange-500" />
                                {' '}{t('account_button.accept')}<a className="text-orange-600" target="_blank" href={generate("cgv")}>{t('account_button.cgv')}</a>.
                            </label>
                        </div>
                        <FieldContainer form="sign_up" name="cgv">
                            <ErrorContainer form="sign_up" name="cgv" />
                        </FieldContainer>

                        <div className="flex justify-center">
                            <Button
                                type="submit"
                                disabled={pristine || submitting || invalid}
                                loading={submitting}
                                icon={pristine || invalid ? "ban" : "check"}
                                className="rounded-md m-auto bg-orange-500 p-3 text-white"
                            >
                                {t('account_button.create_my_account')}
                            </Button>
                        </div>
                    </form>
                );
            }}
        </Form>
    )
}